import React from 'react'
import PropTypes from 'prop-types'
import { Link, useRouteMatch } from 'react-router-dom'
import { Card, HyperButton } from '@offerzen/pinata'

import JobCardHeader from '@/CandidateExperience/components/JobCardHeader'
import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

import styles from './styles'

const ApplicationCard = ({ application }) => {
  const { position, interviewRequest, status } = application
  const match = useRouteMatch()
  const { candidateSlug } = match.params

  return (
    <Card className={styles.card}>
      <JobCardHeader
        companyImage={position.company.logoMediumUrl}
        companyBrandColor={position.company.brandColor}
        companyName={position.company.name}
        jobTitle={position.name}
        jobDetailsHref={`/candidate/${candidateSlug}/recommended-jobs/${position.id}`}
        applicationStatus={status}
      />

      <div className={styles.buttonWrapper}>
        <HyperButton
          label="View details"
          href={{ pathname: `/candidate/${candidateSlug}/recommended-jobs/${position.id}`, state: { previousLocation: match.url } }}
          as={Link}
          variant="outlined"
        />

        <If condition={status === ApplicationStatus.Accepted}>
          <HyperButton
            label="View message"
            href={{
              pathname: `/candidate/${candidateSlug}/interview_requests/${interviewRequest.id}`,
              state: { previousLocation: match.url },
            }}
            as={Link}
          />
        </If>
      </div>
    </Card>
  )
}

ApplicationCard.propTypes = {
  application: PropTypes.shape({
    status: PropTypes.string,
    position: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      company: PropTypes.shape({
        logoMediumUrl: PropTypes.string,
        brandColor: PropTypes.string,
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    interviewRequest: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

export default ApplicationCard
